import { useState } from "react";
import { Box, Container, Grid, Typography, useTheme } from "@mui/material";

import {
  GuestCheckout,
  LoginCheckout,
  NoAccount,
  Confirmation,
  OrderSummary,
} from "@/components/Checkout";
import Logo from "@/components/UI-Kit/Logo";
import useResponsive from "@/hooks/useResponsive";
import { getLeftSideWrapperStyles } from "./styles";
// import {ICheckoutData} from "@/components/Checkout/GuestCheckout/GuestCheckout.tsx";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const Checkout = () => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "sm");

  const FIRST_STEP = 0;
  const steps = { login: 0, form: 1, confirmation: 2 };
  const [checkoutStep, setCheckoutStep] = useState(FIRST_STEP);
  const [checkoutData, setCheckoutData] = useState<ICheckoutForm | null>(null);

  // Order summary state
  const [orderSummary, setOrderSummary] = useState<IOrderSummary>({
    order: [],
    subtotal: 0,
    shipping: 0,
    tax: 0,
    discount: 0,
    promoCodeId: null,
  });

  // Handle next step
  const handleNext = () => {
    setCheckoutStep((prevStep) => prevStep + 1);
  };

  return (
    <>
      {checkoutStep !== steps.confirmation ? (
        <Grid container component="main">
          <Grid
            item
            component="section"
            xs={12}
            md={6}
            sx={{ pt: { xs: 0, md: 4 }, pb: { xs: 5, md: 10, lg: 20 } }}
          >
            <Box
              maxWidth={760}
              boxSizing="border-box"
              ml="auto"
              mr={{ xs: "auto", md: 0 }}
              pl={{ xs: 2, sm: 3 }}
              pr={{ xs: 2, sm: 3, md: 4 }}
            >
              <Box
                maxWidth={checkoutStep === steps.login ? 518 : 662}
                mx="auto"
                boxSizing="border-box"
              >
                <Box
                  py={{ xs: 2.5, md: 4, lg: 5 }}
                  textAlign={{ xs: "center", md: "start" }}
                >
                  <Logo
                    type="dark"
                    width={isMobile ? 132 : 204}
                    height={isMobile ? 25 : 38}
                  />
                </Box>
                <Typography
                  variant="h1"
                  color="text.primary"
                  mb={{ xs: 4, md: 6, lg: 7.5 }}
                >
                  Checkout
                </Typography>

                {checkoutStep === steps.login && (
                  <LoginCheckout
                    goToLoginCheckout={handleNext}
                    setCheckoutData={setCheckoutData as any}
                  />
                )}
                {checkoutStep === steps.form && (
                  <GuestCheckout
                    goToConfirmation={handleNext}
                    orderSummary={orderSummary}
                    setOrderSummary={setOrderSummary}
                    checkoutData={checkoutData || undefined}
                    setCheckoutData={setCheckoutData}
                  />
                )}
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            component="section"
            xs={12}
            md={6}
            bgcolor={{ xs: theme.palette.grey[300], md: "background.default" }}
            sx={getLeftSideWrapperStyles(checkoutStep === steps.login)}
          >
            <Box
              maxWidth={760}
              boxSizing="border-box"
              mr="auto"
              pr={{ xs: 2, sm: 3 }}
              pl={{ xs: 2, sm: 3, md: 4 }}
            >
              <Box
                maxWidth={checkoutStep === steps.login ? 428 : 580}
                boxSizing="border-box"
                mx="auto"
              >
                {checkoutStep === steps.login && (
                  <NoAccount goToGuestCheckout={handleNext} />
                )}

                {checkoutStep === steps.form && (
                  <OrderSummary
                    setOrderSummary={setOrderSummary}
                    orderSummary={orderSummary}
                  />
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Box
          component="main"
          pt={{ xs: 0, md: 8, lg: 10.5 }}
          pb={{ xs: 7.5, md: 12 }}
        >
          <Container>
            <Confirmation />
          </Container>
        </Box>
      )}
    </>
  );
};

export default Checkout;
